import React from 'react';

import StatusSummaryButton from '../../../status/statusSummaryButton.jsx';
import partnerPropTypes from '../../../partnerPropTypes.js';
import { data as paymentDataPropTypes } from '../../../paymentPropTypes.js';

const DiscountSuggestedSummary = ({ partner, payment }) => {
    let statusSummary;
    let body;
    let actionRequiredType;

    if (payment.performedBy === 'SELLER') {
        statusSummary = `${partner.name} avslo prisavslaget.`;
        body = `${partner.name} foreslår et annet prisavslag`;
        actionRequiredType = 'NEGATIVE';
    } else {
        statusSummary = 'Du har foreslått et prisavslag.';
        body = `Venter på svar fra ${partner.name}`;
    }

    return (
        <StatusSummaryButton
            href="/losning/avslag-foreslatt"
            statusSummary={statusSummary}
            actionRequiredType={actionRequiredType}
        >
            {body}
        </StatusSummaryButton>
    );
};

DiscountSuggestedSummary.propTypes = {
    partner: partnerPropTypes.isRequired,
    payment: paymentDataPropTypes.isRequired,
};

export default DiscountSuggestedSummary;



// WEBPACK FOOTER //
// ./safeTrade/buyer/resolution/summaries/discountSuggestedSummary.jsx